module.exports = __webpack_public_path__ + "static/media/3 01 Tulleord Intro.cdd29c69.mp3";